import axios from '@/utils/api'

const actions = {
  redirectToPortal () {
    axios({
      url: 'redirect/portal',
      method: 'GET'
    }).then((data) => {
      window.location.href = data
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/redirect.js